import { FormControl, FormGroup, Validators } from '@angular/forms';

import { FileContentForm } from './file-content-form';

export class FileForm extends FormGroup<{
  id: FormControl<undefined | number>;
  filename: FormControl<undefined | string>;
  filetype: FormControl<undefined | string>;
  filesize: FormControl<undefined | string | number>;
  FileContentId: FormControl<undefined | number>;

  FileContent: FileContentForm;
}> {
  constructor() {
    super({
      id: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      filename: new FormControl<undefined | string>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      filetype: new FormControl<undefined | string>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      filesize: new FormControl<undefined | string | number>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      FileContentId: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),

      FileContent: new FileContentForm()
    });
  }
}
